import React, { useMemo } from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import slugify from "@sindresorhus/slugify";
import { Link } from "./link";

const ModuleHomeBanner = ({ module, isFirst }) => {
  const homeBanners = useMemo(() => {
    return module.titleFieldSet
      .filter((banner) => banner.imageFieldSet && banner.imageFieldSet.image)
      .map((banner) => ({
        ...banner,
        title: banner.title,
        images: withArtDirection(getImage(banner.imageFieldSet.image.node), [
          {
            media: "(max-width: 576px)",
            image: getImage(banner.imageFieldSet.image.nodeMobile),
          },
        ]),
        altImage: banner.imageFieldSet ? banner.imageFieldSet.altImage : "",
      }))
      .slice(0, 2)
      .sort((a, b) => {
        const posA = parseInt(a.positionSection?.[0]);
        const posB = parseInt(b.positionSection?.[0]);
        return isNaN(posA) || isNaN(posB) ? (isNaN(posA) ? 1 : -1) : posA - posB;
      });
  }, [module.titleFieldSet]);

  return (
    <>
      {module.anchorDesktop && (
        <span id={slugify(module.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <section className="section home-banner__section">
        <div className="container-fluid">
          <div className="row justify-content-center">
            {homeBanners.map((item, i) => (
              <div className="col-md-6 px-0" key={i}>
                <div className="home-banner">
                  <GatsbyImage
                    className="home-banner__image"
                    image={item.images}
                    alt={item.altImage}
                  />
                  <div className="home-banner__content d-flex flex-column justify-content-center align-items-center home-banner__content-inner">
                    <div className="text-center ">
                      {item?.title && (
                        <>
                          {isFirst ? (
                            <h1 className="home-banner__title heading-md-semibold">{item.title}</h1>
                          ) : (
                            <h2 className="home-banner__title heading-md-semibold">{item.title}</h2>
                          )}
                        </>
                      )}
                      {item.description && (
                        <div
                          className="home-banner__description text-sm-medium"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></div>
                      )}
                      {item.labelFieldSet && item.labelFieldSet.label && item.labelFieldSet.link && (
                        <div className="text-center home-banner__button">
                          <Link
                            to={item.labelFieldSet.link}
                            className="home-banner__link button tertiary"
                          >
                            {item.labelFieldSet.label}
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

const HomeBanner = ({ data, isFirst }) => {
  const modules = useMemo(
    () =>
      data.moduleTitleFieldSet.length
        ? data.moduleTitleFieldSet
            .filter(
              (module) =>
                module.titleFieldSet.filter(
                  (item) => item.imageFieldSet && item.imageFieldSet.image
                ).length
            )
            .sort((a, b) => {
              const posA = parseInt(a.positionSection?.[0]);
              const posB = parseInt(b.positionSection?.[0]);
              return isNaN(posA) || isNaN(posB) ? 0 : posA - posB;
            })
        : data.moduleTitleFieldSet,
    [data.moduleTitleFieldSet]
  );
  return (
    <>
      {modules.map((module, i) => (
        <ModuleHomeBanner module={module} key={i} isFirst={isFirst} />
      ))}
    </>
  );
};

export default HomeBanner;
export const fragment = graphql`
  fragment ServiceFragment on LiferayService {
    id
    liferayFields {
      siteId
      articleId
    }
    moduleTitleFieldSet {
      anchorDesktop
      anchorMobile
      position
      titleFieldSet {
        title
        positionSection
        imageFieldSet {
          image {
            node {
              gatsbyImageData(width: 1024, layout: CONSTRAINED)
            }
            nodeMobile: node {
              gatsbyImageData(height: 300, aspectRatio: 1.25, layout: CONSTRAINED)
            }
          }
          altImage
        }
        description
        labelFieldSet {
          link
          label
        }
      }
    }
  }
`;
